import ApiService from '@/common/api/api.service';

const urlBaseDocumentoContabil = 'DocumentoContabil';

const DocumentoContabilService = {
  async carregarInformacoesPorId(id) {
    const { data } = await ApiService.get(`${urlBaseDocumentoContabil}/${id}`);
    const response = {
      ...data.data,
      categoriaId: data.data.categoria,
    };
    return response;
  },
  async criar(form) {
    delete form.categoriaId;
    delete form.itens;
    let result = await ApiService.post(`${urlBaseDocumentoContabil}`, form);
    return result;
  },
  async atualizar(form) {
    delete form.categoriaId;
    delete form.itens;
    let result = await ApiService.put(`${urlBaseDocumentoContabil}`, form);
    return result;
  },
  async excluir(itemId) {
    let result = await ApiService.delete(
      `${urlBaseDocumentoContabil}/${itemId}`
    );
    return result;
  },
  async obterPor(parametros) {
    let { data } = await ApiService.get(
      `${urlBaseDocumentoContabil}/obter-por-filtro`,
      { params: { ...parametros } }
    );
    return data;
  },
  async buscarCategorias() {
    let { data } = await ApiService.get(
      `enumeradores/categoria-documento-contabil`
    );
    return data.data;
  },
  async salvarDocumentoItem(form) {
    const { data } = await ApiService.post(
      `${urlBaseDocumentoContabil}/documento-contabil-item`,
      form
    );
    return data;
  },
  async atualizarDocumentoItem(form) {
    const { data } = await ApiService.put(
      `${urlBaseDocumentoContabil}/documento-contabil-item`,
      form
    );
    return data;
  },
  async excluirDocumentoItem(params) {
    let { data } = await ApiService.delete(
      `${urlBaseDocumentoContabil}/documento-contabil-item?documentoContabilItemId=${params.documentoContabilItemId}&DocumentoContabilId=${params.documentoContabilId}`
    );
    return data;
  },
  async obterDocumentosContabeisItensPorDocumentoContabilId(id) {
    const { data } = await ApiService.get(
      `${urlBaseDocumentoContabil}/obter-por-documento-contabil-id?id=${id}`
    );
    return data;
  },
};

export default DocumentoContabilService;
